import { Image } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

// Fila para asentar las etiquetas sobre la esquina de la imagen (sin usar position: absolute ni z-index)
export const EtiquetasRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	padding-left: 8px;
	margin-bottom: -16px;
	height: clamp(22px, 9cqw, 32px);
`;

export const EtiquetaDGTImg = styled(Image)<{ index: number }>`
	width: clamp(22px, 9cqw, 32px);
	height: auto;
	margin-left: ${({ index }) => (index === 0 ? '0px' : `clamp(-14px, -6cqw, -6px)`)};
`;

export const EtiquetaDGTImgVehicleSelected = styled(EtiquetaDGTImg)`
	width: clamp(32px, 9cqw, 60px);
`;

export const EtiquetasRowVehicleSelected = styled(EtiquetasRow)`
	padding-left: var(--size-dynamic0200);
	padding-top: var(--size-dynamic0050);
	margin-bottom: clamp(-70px, -8cqw, -50px);
	height: clamp(32px, 9cqw, 60px);
`;
